import { Component, OnInit } from "@angular/core"

@Component({
    selector: "app-column-template",
    templateUrl: "./column-template.component.html",
    styleUrls: ["./column-template.component.scss"],
    standalone: false
})
export class ColumnTemplateComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
